<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="80%" append-to-body :before-close="handleClose">
    <el-form :model="form" inline style="height:60vh;overflow:auto" label-width="80px">
      <el-form-item label="促销单号:">
        <div class="form-width-xs text-out">
          {{form.docNum}}
        </div>
      </el-form-item>
      <el-form-item label="购买日期:">
        <div :title="form.docDate" class="form-width-xs text-out">
          {{form.docDate}}
        </div>
      </el-form-item>
      <el-form-item label="会员名字:">
        <div class="form-width-xs">
          {{form.memberName }}
        </div>
      </el-form-item>
      <el-form-item label="手机号码:">
        <div class="form-width-xs">
          {{form.mobilePhone }}
        </div>
      </el-form-item>
      <el-form-item label="促销名称:">
        <div class="form-width-xs">
          {{form.promotionName }}
        </div>
      </el-form-item>
      <br>
      <el-form-item label="标准单价:">
        <div class="form-width-xs">
          {{form.price }}
        </div>
      </el-form-item>
      <el-form-item label="购买套数:">
        <div class="form-width-xs">
          {{form.count }}
        </div>
      </el-form-item>
      <el-form-item label="成交金额:">
        <div class="form-width-xs">
          {{form.amount }}
        </div>
      </el-form-item>
      <el-form-item label="欠款金额:">
        <div class="form-width-xs">
          {{form.debtMoney }}
        </div>
      </el-form-item>
      <el-form-item label="备注:">
        {{form.description }}
      </el-form-item><br>
      <el-form-item label="买:" v-show="giveProject.length>0"></el-form-item>
      <el-table style="width:800px;margin-left:80px" :data="projectList" :header-cell-style="{background: 'linear-gradient(#6cb3ff, #1873d4)',color:'#eeeeee',}">
        <el-table-column prop="projectNum" label="项目编码" align="center" min-width="120"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="center" min-width="120"></el-table-column>
        <el-table-column prop="priceMember" label="标准价" align="center" min-width="120"></el-table-column>
        <el-table-column prop="times" label="次数" align="center" min-width="120"></el-table-column>
        <el-table-column prop="projectTotalMoney" label="总价值" align="center" min-width="120"></el-table-column>
      </el-table>
      <el-form-item label="送:" v-show="giveProject.length>0"></el-form-item>
      <el-table style="width:800px;margin-left:80px" :data="giveProject" v-if="giveProject.length>0" :header-cell-style="{background: 'linear-gradient(#6cb3ff, #1873d4)',color:'#eeeeee',}">
        <el-table-column prop="projectNum" label="项目编码" align="center" min-width="120"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="center" min-width="120"></el-table-column>
        <el-table-column prop="priceMember" label="标准价" align="center" min-width="120"></el-table-column>
        <el-table-column prop="times" label="次数" align="center" min-width="120"></el-table-column>
        <el-table-column prop="projectTotalMoney" label="总价值" align="center" min-width="120"></el-table-column>
      </el-table>
      <div class="padding-top-xs"></div>
      <el-form-item label="充值卡付:">
        <el-table :data="form.rechargeConsumeList" style="width:400px" class="border-radius-10 border margin-right-xs  bg-white padding-xs">
          <el-table-column label="卡付名称" align='center' prop="rechargeTypeName"></el-table-column>
          <el-table-column label="支付金额" align='center' prop="spendMoney"></el-table-column>
          <el-table-column label="剩余金额" align='center' prop="cardConsumeMoney"></el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="现付:">
        <el-table :data="form.payLists" style="width:300px" class="border-radius-10 border margin-right-xs bg-white padding-xs">
          <el-table-column label="支付方式" align='center' min-width="160">
            <template slot-scope="scope">
              <el-select v-model="scope.row.payId" placeholder="请选择" style="width: 150px;">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="支付金额" prop="payMoney" align='center' min-width="120"></el-table-column>
        </el-table>
      </el-form-item>
      <br>
      <el-form-item style="display: inline-block;" label="业务员：">
        <div class="flex justify-start align-start ">
          <staffsles ref="staffsles" @staffslesData="staffslesData"></staffsles>
          <admin ref="admin" @adminData="adminData"></admin>
          <manager ref="manager" @managerData="managerData"></manager>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="title=='明细'">
      <el-button size="mini" type="primary" @click="detailDialog=false">关闭</el-button>
    </span>
    <span v-else slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="handleClose()">取 消</el-button>
      <el-button v-if="form.isCancel==0" size="mini" :loading="loading" type="primary" @click="subStaffRatio(loading=true)">修 改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { selectOne,ctlist } from "@/api/eashier.js";
import { docPromotionEditStaff } from "@/api/home.js";
import {
  docPromotionProList,
  docPromotionProListNew,
} from "@/api/promotion.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
export default {
  components: {
    staffsles,
    manager,
    admin,
  },
  data() {
    return {
      options:[],
      detailDialog: false, //明细弹窗开关
      sessionStorageData: {}, //门店参数集合
      form: {}, //主对象
      title: "", //弹窗标题
      loading: false, //提交动画
      projectList: [], //购买项目
      giveProject: [], //赠送项目
    };
  },
  methods: {
    init(){
      ctlist({
        state: 1
      }).then(res=>{
        this.options = res.rows.map(item=>{
          return {
            value:item.id,
            label:item.collectionTypeName
          }
        })
      })
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = {};
      this.projectList = [];
      this.giveProject = [];
      this.$emit("detailData");
      this.detailDialog = false;
    },

    //员工占比返回方法
    staffslesData(v) {
      this.form.entities = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    //组件传值
    show(form, text) {
      if (text == "明细") {
        this.title = text;
      } else {
        this.title = "明细/修改";
      }
      this.detailDialog = true;
      this.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      this.getData(form);
    },
    //获取数据
    getData(row) {
      this.form = row;
      this.form.entities.forEach((item) => {
        item.staffName = item.saleStaffName;
        item.id = item.saleStaffId;
        item.identityCard = item.saleIdentityCard;
        item.ratio = item.saleRatio;
        item.staffNames = item.brandNumber + "--" + item.staffName;
      });
      selectOne({ type: 8, orderId: row.id }).then((res) => {
        if (res.code == "000000") {
          let managerList = [];
          let adminList = [];
          res.rows.forEach((item) => {
            if (item.staffType == 0) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              managerList.push(item);
            }
            if (item.staffType == 1) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              adminList.push(item);
            }
          });
          if (managerList.length == 0) {
            managerList.push({ ratio: 100 });
          }
          if (adminList.length == 0) {
            adminList.push({ ratio: 100 });
          }
          if (this.form.entities.length == 0) {
            this.form.entities.push({ ratio: 100 });
          }
          this.form.managerLists = managerList;
          this.form.adminList = adminList;
          var that = this;
          this.$nextTick(() => {
            that.$refs.staffsles.show(that.form.entities);
            that.$refs.manager.show(that.form.managerLists);
            that.$refs.admin.show(that.form.adminList);
          });
        } else {
          this.$alert(res.message, "加载门店高管", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });

      docPromotionProListNew({
        docNum: row.docNum,
        promotionId: row.promotionId,
        storeId: row.storeId,
      }).then((res) => {
        if (res.code == "000000") {
          let projectList = [];
          let giveProject = [];
          if (res.code == "000000") {
            res.rows.forEach((item) => {
              if (item.type == 0) {
                projectList.push(item);
              } else {
                giveProject.push(item);
              }
            });
            this.projectList = projectList;
            this.giveProject = giveProject;
          }
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },

    //指定列求和
    //数组按对应字段合计返回方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property == "spendMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else if (column.property == "payMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    //提交修改员工占比
    subStaffRatio() {
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      let salesmens = [];
      this.form.managerLists.forEach((item) => {
        if (item.id) {
          item.staffType = 0;
          salesmens.push(item);
        }
      });
      this.form.adminList.forEach((item) => {
        if (item.id) {
          item.staffType = 1;
          salesmens.push(item);
        }
      });
      let ids = {
        id: this.form.id,
        staffLists: this.form.entities,
        collectionCashAmount: this.form.collectionCashAmount,
        collectionRechargeAmount: this.form.collectionRechargeAmount,
        promotionNum: this.form.promotionNum,
        docDate: this.form.docDate,
        salesmens: salesmens,
        payLists:this.form.payLists
      };
      docPromotionEditStaff(ids).then((res) => {
        this.loading = false;
        if (res.code == "000000") {
          this.$emit("detailData");
          this.detailDialog = false;
          this.$message.success({
            message: res.message,
          });
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
  created(){
    this.init()
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/promotion/sellpacking/components/detail.vue